import React, { useEffect, useState, useRef } from 'react';
import { X, Send, User, Search } from 'lucide-react';
interface ShareQuestionModalProps {
  questionId: number;
  questionTitle: string;
  onClose: () => void;
  onShare: (data: {
    recipientId: string;
    note: string;
  }) => void;
}
export function ShareQuestionModal({
  questionId,
  questionTitle,
  onClose,
  onShare
}: ShareQuestionModalProps) {
  const [recipientId, setRecipientId] = useState('');
  const [note, setNote] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const searchRef = useRef<HTMLDivElement>(null);
  // Available recipients (both teachers and friends)
  const availableRecipients = [
  // Teachers
  {
    id: 't1',
    name: 'Ahmet Yılmaz',
    role: 'Matematik Öğretmeni'
  }, {
    id: 't2',
    name: 'Zeynep Kaya',
    role: 'Türkçe Öğretmeni'
  }, {
    id: 't3',
    name: 'Mehmet Demir',
    role: 'Fen Bilimleri Öğretmeni'
  }, {
    id: 't4',
    name: 'Ayşe Şahin',
    role: 'İngilizce Öğretmeni'
  },
  // Friends/Classmates
  {
    id: 's1',
    name: 'Ali Öztürk',
    role: 'Sınıf Arkadaşı'
  }, {
    id: 's2',
    name: 'Fatma Çelik',
    role: 'Sınıf Arkadaşı'
  }, {
    id: 's3',
    name: 'Mustafa Aydın',
    role: 'Sınıf Arkadaşı'
  }, {
    id: 's4',
    name: 'Hatice Yıldız',
    role: 'Sınıf Arkadaşı'
  }];
  // Filter recipients based on search term
  const filteredRecipients = availableRecipients.filter(recipient => recipient.name.toLowerCase().includes(searchTerm.toLowerCase()) || recipient.role.toLowerCase().includes(searchTerm.toLowerCase()));
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleSelectRecipient = (id: string, name: string) => {
    setRecipientId(id);
    setSearchTerm(name);
    setShowDropdown(false);
  };
  const handleSubmit = () => {
    if (!recipientId) return;
    onShare({
      recipientId,
      note
    });
    onClose();
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto bg-black/75 flex items-center justify-center" data-id="element-1019">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full max-w-md mx-4" data-id="element-1020">
        <div className="relative bg-black/90 rounded-xl" data-id="element-1021">
          <div className="p-4 border-b border-gray-800 flex justify-between items-center" data-id="element-1022">
            <h2 className="text-xl font-bold" data-id="element-1023">Soruyu Paylaş</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-1024">
              <X className="w-6 h-6" data-id="element-1025" />
            </button>
          </div>
          <div className="p-6 space-y-6" data-id="element-1026">
            <div data-id="element-1027">
              <p className="text-gray-400 text-sm" data-id="element-1028">Paylaşılacak soru:</p>
              <p className="font-medium mt-1" data-id="element-1029">{questionTitle}</p>
            </div>
            <div className="space-y-2" ref={searchRef} data-id="element-1030">
              <label className="block text-sm font-medium text-gray-300" data-id="element-1031">
                Alıcı
              </label>
              <div className="relative" data-id="element-1032">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1033" />
                <input type="text" value={searchTerm} onChange={e => {
                setSearchTerm(e.target.value);
                setShowDropdown(true);
              }} onFocus={() => setShowDropdown(true)} className="w-full bg-white/5 text-white rounded-lg pl-10 pr-4 py-3 focus:ring-2 ring-purple-500/20" placeholder="Kişi ara..." data-id="element-1034" />
                {showDropdown && searchTerm && <div className="absolute z-10 mt-1 w-full bg-gray-900 rounded-lg shadow-lg border border-gray-800 max-h-60 overflow-y-auto" data-id="element-1035">
                    {filteredRecipients.length > 0 ? filteredRecipients.map(recipient => <button key={recipient.id} onClick={() => handleSelectRecipient(recipient.id, recipient.name)} className="w-full px-4 py-2 text-left hover:bg-gray-800 text-white flex items-center gap-2" data-id="element-1036">
                          <User className="w-4 h-4 text-gray-400" data-id="element-1037" />
                          <div data-id="element-1038">
                            <div className="font-medium" data-id="element-1039">{recipient.name}</div>
                            <div className="text-xs text-gray-400" data-id="element-1040">
                              {recipient.role}
                            </div>
                          </div>
                        </button>) : <div className="px-4 py-3 text-gray-400 text-center" data-id="element-1041">
                        Sonuç bulunamadı
                      </div>}
                  </div>}
              </div>
            </div>
            <div className="space-y-2" data-id="element-1042">
              <label className="block text-sm font-medium text-gray-300" data-id="element-1043">
                Not (İsteğe Bağlı)
              </label>
              <textarea value={note} onChange={e => setNote(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-3 min-h-[100px] focus:ring-2 ring-purple-500/20" placeholder="Soruyla ilgili bir not ekleyin..." data-id="element-1044" />
            </div>
          </div>
          <div className="p-4 border-t border-gray-800 flex justify-end gap-3" data-id="element-1045">
            <button onClick={onClose} className="px-4 py-2 bg-white/5 hover:bg-white/10 text-white rounded-lg transition-colors" data-id="element-1046">
              İptal
            </button>
            <button onClick={handleSubmit} disabled={!recipientId} className={`px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg flex items-center gap-2 ${!recipientId ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'}`} data-id="element-1047">
              <Send className="w-4 h-4" data-id="element-1048" />
              Gönder
            </button>
          </div>
        </div>
      </div>
    </div>;
}